import React from 'react';
import { DateTimeService } from 'services/datetime-service';
import { RequestFormViewModel } from 'stores/requests/request-form-store';
import { RequestDto } from 'stores/requests/requests-store';
import { getBaseColor } from 'utils/useful-functions';
import { CountryFlag } from 'widgets/bussiness/country-flag';
import { MachineListItemViewModel } from '../shared/events-and-requests/machine-list-item';

interface MobileRequestElementContainerProps {
  request: RequestFormViewModel; // El signo ? hace que sea opcional
  selectedRequest: RequestDto;
  onClick?: (request: RequestDto) => void;
}

const MobileRequestElementContainer: React.FC<MobileRequestElementContainerProps> = ({ request, selectedRequest, onClick }) => {
  const color = getBaseColor(request.eventTypeColor);

  const getRequestSlot = (request: RequestFormViewModel): string => {
    return `${DateTimeService.toDateInputString(request.startDate)} - ${DateTimeService.toDateInputString(request.endDate)}`;
  };

  const getRequestTitle = (request: RequestFormViewModel): string => {
    return `${request.friendlyId} - ${request.title}`;
  };

  const getRequestEventType = (request: RequestFormViewModel): string => {
    return `${request.eventTypeName}`;
  };

  const getMachineModelName = (machine: MachineListItemViewModel): string => {
    if (!machine || !machine.machineModel) {
      return '';
    }
    return machine.machineModel.title;
  };

  const getRequestMachines = (request: RequestFormViewModel): string => {
    if (request && request.machineRelated && (request.machines || []).length > 0) {
      const machines = (request.machines || []).map(i => getMachineModelName(i));
      if (machines.length > 2) {
        return `${machines.slice(0, 3).join(', ')} , ...`;
      }
      return machines.join(', ');
    } else return '';
  };

  return (
    <div onClick={() => onClick(selectedRequest)} className="border-l-4 p-3 mb-2 cursor-pointer shadow-md" style={{ borderColor: color }}>
      <div className="flex items-center gap-2">
        <div
          style={{
            width: '10px',
            height: '10px',
            borderRadius: '50%',
            backgroundColor: color
          }}
        ></div>
        <p className="text-sm text-gray-500">{getRequestEventType(request)}</p>
      </div>
      <h4 className="text-black-600 font-semibold">{getRequestTitle(request)}</h4>
      <p className="text-xs text-gray-500">{getRequestSlot(request)}</p>
      {getRequestMachines(request) && (
        <p className="text-sm flex items-center gap-1">
          <span>
            <svg
              className="w-[16px] h-[16px] text-gray-800 dark:text-white"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="19"
              height="19"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.6"
                d="M21 13v-2a1 1 0 0 0-1-1h-.757l-.707-1.707.535-.536a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-.536.535L14 4.757V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v.757l-1.707.707-.536-.535a1 1 0 0 0-1.414 0L4.929 6.343a1 1 0 0 0 0 1.414l.536.536L4.757 10H4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h.757l.707 1.707-.535.536a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l.536-.535 1.707.707V20a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-.757l1.707-.708.536.536a1 1 0 0 0 1.414 0l1.414-1.414a1 1 0 0 0 0-1.414l-.535-.536.707-1.707H20a1 1 0 0 0 1-1Z"
              />
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.6"
                d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
              />
            </svg>
          </span>
          {getRequestMachines(request)}
        </p>
      )}
      <p className="text-sm">
        <CountryFlag
          countryName={
            selectedRequest?.requestLocation?.code !== 'XXXX' && selectedRequest?.requestLocation?.code !== 'XXXXX'
              ? selectedRequest.requestingLocationCountryName
              : null
          }
        />
        &nbsp;{request?.requestingLocation?.title}
      </p>
      <div className="text-sm mb-1">{request?.status && <span className="block">Status: {request?.status}</span>}</div>
    </div>
  );
};

export default MobileRequestElementContainer;
